import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { categories } from '@/mocks/home';

export default function Categories() {
  return (
    <section id="categories" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="内容专区"
          title="十个专区，覆盖你能想到的每一种看得爽"
          desc="从歌舞才艺到游戏电竞，再到深夜电台与萌宠日常，按专区进就能找到同频的主播。"
        />

        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
          {categories.map((item, index) => (
            <Reveal key={item.name} delay={(index % 5) * 60}>
              <a
                href="#live"
                className="group flex h-full cursor-pointer flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 md:p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{item.name}</h3>
                  <p className="mt-1 text-xs text-foreground-500">{item.count}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}